// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeFrameModal .sv:not(.sv-pencil3, .sv-arrow-right) {
  font-size: 1.5rem !important;
}
.TimeFrameModal *:not(.btn-success, .btn-primary, .sv-plus, .sv-floppy-disk, .sv-undo2) {
  color: var(--bs-dark);
}
.TimeFrameModal .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  flex-wrap: nowrap;
}
.TimeFrameModal .dropdown,
.TimeFrameModal .FormField {
  max-width: 24rem;
}
.TimeFrameModal .ant-picker {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.TimeFrameModal .FormField .FormField-Wrapper .grouped-input {
  border: none;
  border-radius: 0 !important;
  border-bottom: solid 1px var(--bs-gray-subtle);
}
.TimeFrameModal .FormField .FormField-Wrapper .grouped-input .form-control {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0.25rem;
  border-radius: 0;
}
.TimeFrameModal .FormField .FormField-Wrapper .grouped-input .form-control:focus {
  box-shadow: none;
}
.TimeFrameModal .FormField .FormField-Wrapper .grouped-input .form-control:disabled + .append {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.TimeFrameModal .FormField .FormField-Wrapper .grouped-input .input-group-text {
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.TimeFrameModal .ant-picker.ant-picker-disabled input {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.TimeFrameModal .TimeFrameRange {
  font-size: 1.2rem;
  padding: 0rem 1.5rem;
  /* Drop Shadow */
  box-shadow: 2px 3px 3px 0 rgba(0, 0, 0, 0.12);
}
.TimeFrameModal .Dropdown {
  flex-grow: 0;
}
.TimeFrameModal .btn {
  --bs-btn-padding-x: 1rem;
  --bs-btn-padding-y: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/TimeFrameModal/styles.scss"],"names":[],"mappings":"AACE;EACE,4BAAA;AAAJ;AAGE;EACE,qBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;AAFJ;AAME;;EAEE,gBAAA;AAJJ;AAOE;EACE,0CAAA;AALJ;AAUM;EACE,YAAA;EACA,2BAAA;EACA,8CAAA;AARR;AAUQ;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AARV;AASU;EACE,gBAAA;AAPZ;AASU;EACE,wCAAA;EACA,UAAA;AAPZ;AAWQ;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AATV;AAeE;EACE,wCAAA;EACA,UAAA;AAbJ;AAgBE;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,6CAAA;AAdJ;AAiBE;EACE,YAAA;AAfJ;AAkBE;EACE,wBAAA;EACA,0BAAA;AAhBJ","sourcesContent":[".TimeFrameModal {\n  .sv:not(.sv-pencil3, .sv-arrow-right) {\n    font-size: 1.5rem !important;\n  }\n\n  *:not(.btn-success, .btn-primary, .sv-plus, .sv-floppy-disk, .sv-undo2) {\n    color: var(--bs-dark);\n  }\n\n  .btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.2rem;\n    flex-wrap: nowrap;\n  }\n\n  // set max width on input and dropdown\n  .dropdown,\n  .FormField {\n    max-width: 24rem;\n  }\n  // set box shadow on input and dropdown\n  .ant-picker {\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);\n  }\n  // the css styles to get the underline input text css styles\n  .FormField {\n    .FormField-Wrapper {\n      .grouped-input {\n        border: none;\n        border-radius: 0 !important;\n        border-bottom: solid 1px var(--bs-gray-subtle);\n        // remove focus effect from text input\n        .form-control {\n          padding-left: 0;\n          padding-right: 0;\n          padding-bottom: 0.25rem;\n          border-radius: 0;\n          &:focus {\n            box-shadow: none;\n          }\n          &:disabled + .append {\n            background-color: var(--bs-secondary-bg);\n            opacity: 1;\n          }\n        }\n        // remove border from append icon\n        .input-group-text {\n          border: none;\n          border-radius: 0;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .ant-picker.ant-picker-disabled input {\n    background-color: var(--bs-secondary-bg);\n    opacity: 1;\n  }\n\n  .TimeFrameRange {\n    font-size: 1.2rem;\n    padding: 0rem 1.5rem;\n    /* Drop Shadow */\n    box-shadow: 2px 3px 3px 0 rgba(0, 0, 0, 0.12);\n  }\n\n  .Dropdown {\n    flex-grow: 0;\n  }\n\n  .btn {\n    --bs-btn-padding-x: 1rem;\n    --bs-btn-padding-y: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
